import { TextV2 } from '@insights-ltd/design-library/components';
import { useTranslation } from 'react-i18next';
const PAGINATION_TEXT_COLOUR = 'textPrimary';

export const PreviousLabel = () => {
  const { t } = useTranslation();
  return (
    <TextV2 sx={{ color: PAGINATION_TEXT_COLOUR }}>
      {t('ui.common.pagination.prev')}
    </TextV2>
  );
};

export const NextLabel = () => {
  const { t } = useTranslation();
  return (
    <TextV2 sx={{ color: PAGINATION_TEXT_COLOUR }}>
      {t('ui.common.pagination.next')}
    </TextV2>
  );
};
